import { render, staticRenderFns } from "./modalEdit.vue?vue&type=template&id=1834b3b9"
import script from "./modalEdit.vue?vue&type=script&lang=js"
export * from "./modalEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports